/**
 * Item de combustível retornado por `PR_SWAP_BUSCA_COMBUSTIVEL_PORTAL`.
 *
 * Em caso de erro de negócio (proc retorna STATUS='ERRO'), o backend
 * traduz para `ApplicationException` com a mensagem de DSC_ERRO; o
 * cliente nunca recebe a "shape" de erro neste tipo.
 */
export interface SwapCombustivel {
  codCombustivel: number;
  dscCombustivel: string;
}
